var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCash = function SvgCash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-7997.549 6513.519 32.296 26.88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .dollar-sign {\n        font-size: 9px;\n        font-family: Helvetica-Bold, Helvetica;\n        font-weight: 700;\n        fill: #DADADA;\n        stroke: none;\n      }\n      .rectangle {\n        stroke-width: 1px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12955",
    "data-name": "Group 12955",
    transform: "translate(-8517.261 6173.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12937",
    "data-name": "Group 12937",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 521.051, 341.598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12934",
    "data-name": "Group 12934",
    transform: "translate(-0.099 17.799) rotate(-57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2318",
    "data-name": "Group 2318",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2948",
    "data-name": "Rectangle 2948",
    className: "rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "rectangle",
    width: 24.279,
    height: 11.862,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "rectangle",
    x: 0.5,
    y: 0.5,
    width: 23.279,
    height: 10.862,
    rx: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12940",
    "data-name": "Group 12940",
    transform: "translate(1.481 10.108) rotate(-34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2318-2",
    "data-name": "Group 2318",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2948-2",
    "data-name": "Rectangle 2948",
    className: "rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "rectangle",
    width: 24.359,
    height: 12.74,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "rectangle",
    x: 0.5,
    y: 0.5,
    width: 23.359,
    height: 11.74,
    rx: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12935",
    "data-name": "Group 12935",
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 5.306, 7.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2318-3",
    "data-name": "Group 2318",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2948-3",
    "data-name": "Rectangle 2948",
    className: "rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "rectangle",
    width: 25.707,
    height: 13.622,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "rectangle",
    x: 0.5,
    y: 0.5,
    width: 24.707,
    height: 12.622,
    rx: 1.5
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "$",
    className: "dollar-sign",
    transform: "matrix(1, -0.017, 0.017, 1, 536.161, 351.076)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7
  }, "$")))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cash.f77265f4.svg";
export { ForwardRef as ReactComponent };